import React, { useEffect, useRef, useState } from "react";
import { MdEdit } from "react-icons/md";
import { CLOUDINARY_CLOUD } from "../constants/CloudinaryConstants";
import { HOST } from "../constants/HostConstants";

const UploadAdvertisement = ({ setUploadedItems, setModal }) => {
  const cloudinaryRef = useRef();
  const widgetRef = useRef();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const init = async () => {
      cloudinaryRef.current = window.cloudinary;
      try {
        const res = await fetch(`${HOST}/api/user/cloudinarySign`);
        if (!res.ok) throw new Error("sign failed");
        const sign = await res.json();
        const opts = {
          cloudName: sign.cloud || CLOUDINARY_CLOUD,
          uploadSignature: sign.signature,
          uploadSignatureTimestamp: sign.timestamp,
          apiKey: sign.api_key,
          // Auto compression during upload
          transformation: [
            {
              quality: "auto:good", // Automatic quality optimization
              fetch_format: "auto", // Auto-select format (AVIF, WebP, JPG, PNG)
              width: 1920, // Max width
              crop: "scale",
            },
          ],
          // Eager transformations (pre-generate optimized versions)
          eager: [
            {
              width: 600,
              height: 600,
              crop: "fill",
              gravity: "auto",
              quality: 80,
              fetch_format: "auto",
            },
          ],
        };
        if (sign.preset) opts.uploadPreset = sign.preset;
        widgetRef.current = cloudinaryRef.current.createUploadWidget(
          opts,
          function (error, result) {
            if (result && result["event"] === "success") {
              setUploadedItems((current) => [
                ...current,
                result["info"]["path"],
              ]);
              setModal(false);
            }
          }
        );
        setReady(true);
      } catch (err) {
setError("Signed uploads unavailable");
      }
    };
    init();
  }, []);
  // Removed accidental profile update logic (not used in this component)
  return (
    <div
      className={`bg-black text-white rounded-10 w-max p-2 mx-auto  m-2 ${
        !ready
          ? "opacity-60 cursor-not-allowed"
          : "hover:scale-105 hover:cursor-pointer"
      } transition-all`}
      onClick={() => {
        if (!ready || !widgetRef.current) {
          alert(error || "Upload not available");
          return;
        }
        widgetRef.current.open();
      }}
    >
      <button>{ready ? "Upload Advertisement" : "Upload unavailable"}</button>
    </div>
  );
};

export default UploadAdvertisement;
